import {Action, Dispatch} from 'redux';
import {ErrorCodeLang} from '../../Config/dataModel';
import {throwErrorClient} from '../../Util/errorUtil';
import errorCodeAPI from '../APIs/errorCodeAPI';
import { getLanguage } from 'src/Util/language';

const TYPES = {
    FETCH_ERROR_CODE_SUCCESS: 'FETCH_ERROR_CODE_SUCCESS'
};

const errorMap = getLanguage() === "zh-hk" ? {
    '000': '伺服器沒有回應。',
    '001': '伺服器超時。',
    '010': '錯誤代碼不存在。',
    '351': '無效的用戶名或密碼。',
} : {
    '000': 'Server unavailable.',
    '001': 'Server timeout.',
    '010': 'Error code not found.',
    '351': 'Invalid Username or Password.',
};


const fetchErrorCode = (data: ErrorCodeLang) => {
    return function (dispatch: Dispatch<Action>) {
        return errorCodeAPI.errorCode(data).then(res => {
            dispatch(storeErrorCode(Object.assign(errorMap, res.data)));
        }).catch(error => {
            throwErrorClient(0);
        });
    };
};

const storeErrorCode = (data: object) => {
    return {
        type: TYPES.FETCH_ERROR_CODE_SUCCESS,
        errorCode: data
    };
};

const getErrorCode = () => {
    return errorMap;
};

export {TYPES, fetchErrorCode, getErrorCode};


// WEBPACK FOOTER //
// ./src/ReduxRequests/Actions/errorCodeAction.ts